import { DesignedMap } from '../components/designedMap';
import React from 'react';
import parseStateFromUrl from '../helpers/parseStateFromUrl';

const Print = ({ scale = 8 }) => (
  <DesignedMap scale={scale} print={true} {...parseStateFromUrl()} />
);

export default Print;
